import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { UploadImageDialog } from 'components';

class EditableImage extends Component {
  static propTypes = {
    image: PropTypes.string,
    isBanner: PropTypes.bool,
    requesting: PropTypes.bool,

    renderer: PropTypes.func,
    onUpload: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
  };

  static defaultProps = {
    image: '',
    isBanner: false,
    requesting: false,

    renderer: () => null,
  };

  state = { open: false };

  onClick = (e) => {
    e.stopPropagation();
    this.setState({ open: true });
  }

  onClose = () => this.setState({ open: false });

  handleUpload = (payload) => {
    this.props.onUpload({
      ...payload,
      onRequestClose: this.onClose,
    });
  };

  handleRemove = () => {
    this.props.onRemove({
      onRequestClose: this.onClose,
    });
  };

  render() {
    const {
      image,
      isBanner,
      requesting,
      renderer,
      ...props
    } = this.props;
    const { open } = this.state;

    const { onClick, onClose } = this;

    const uploadImageDialog = (
      <UploadImageDialog
        {...props}
        image={image}
        isBanner={isBanner}
        onClose={onClose}
        open={open}
        requesting={requesting}
        onRemove={this.handleRemove}
        onUpload={this.handleUpload}
      />
    );
    return renderer({ ...props, onClick, uploadImageDialog });
  }
}

export default EditableImage;
